// HeaderBanner.jsx
import React, { useEffect, useState } from "react";
import "./HeaderBanner.css";

const textMessages = [
    "RO Repair",
    "RO Installation",
    "RO Routine and AMC Service",
    "24x7 RO Service Support",
    "Fast RO Service at Your Doorstep"
];

const HeaderBanner = () => {
    const [index, setIndex] = useState(0);
    const [animate, setAnimate] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimate(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % textMessages.length);
                setAnimate(true);
            }, 500); // time for disappear animation
        }, 2000); // total cycle

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="banner">


            <div id="home_section" className="section banner_section banner_half_content bg_gray pb-0">
                <div className="banner_content_wrap">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-xl-6 col-md-7">
                                <div className="banner_content banner_center_content text-center text-md-left">
                                    <h2 className="animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.02s" style={{animationDelay:'0.02s', opacity:1}}>WATER PURIFIER SERVICES <br />  @18005691061 </h2>
                                    <div id="typed-strings" className="d-none" style={{fontSize:'30px'}} >
                                                                            <h4 className="animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.03s" style={{animationDelay:'0.03s', opacity:1}}>We Provides <span id="typed-text" className="text_default"></span><span className="typed-cursor"></span></h4> <span  style={{ color: 'blue'}}><b>{textMessages[index]}</b></span>
                                    </div>

                                    <p className="animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.04s" style={{animationDelay:'0.04s', opacity:1, fontSize:'26px'}}><b>Company Name: WATER PURIFIER SERVICES</b></p>
                                    <div className="call-action-area"><a href="/#contact" className="btn btn-default rounded-0 button">Service Booking</a> &nbsp; &nbsp; <a href="tel:18005691061" className="btn btn-default-1 rounded-0"><i className="fa fa ion-android-call">&nbsp;</i> 18005691061</a></div>
                                </div>
                            </div>
                            <div className="col-xl-5 col-md-5">
                                <div className="banner_img animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.02s" style={{animationDelay:'0.02s', opacity:1}}>
                                    <img src="img/banners/repairimg2.png" alt="my_image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape_wrap">
                    <div className="shape1">
                        <div className="animation1">
                            <img src="img/banners/shape1.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape2">
                        <div className="animation2">
                            <img src="img/banners/shape2.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape3">
                        <div className="animation5">
                            <img src="img/banners/shape3.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape4">
                        <div className="animation6">
                            <img src="img/banners/shape4.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape5">
                        <div className="animation5">
                            <img src="img/banners/shape5.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape6">
                        <div className="animation1">
                            <img src="img/banners/shape6.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape7">
                        <div className="animation5">
                            <img src="img/banners/shape7.png" alt="shape" />
                        </div>
                    </div>
                    <div className="shape8">
                        <div className="animation2">
                            <img src="img/banners/shape8.png" alt="shape" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderBanner;
